export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

export const ERROR_MESSAGES: Record<string, string> = {
    SIGN_IN_FAILED: 'Sign in failed. Please check your email and password.',
    PASSCODE_NOT_ACCEPTED: 'That code was not accepted. It may have expired or already been used.',
    ACCOUNT_LOCKED: 'Your account is locked after too many attempts. Please try again later.',
    ACCOUNT_INACTIVE: 'Your account is inactive. Please contact an administrator.',
    ACCOUNT_PENDING_ACTIVATION: 'Your invitation has not been accepted yet. Please use your activation link.',
    PASSWORD_RESET_REQUIRED: 'You need to reset your password before you can continue.',
    LINK_REFUSED: 'This link is no longer usable. Please request a new one.',
    PASSWORD_UNCHANGED: 'Your new password must be different from your current one.',
    PASSWORDS_DO_NOT_MATCH: 'Password and confirmation do not match.',
    CURRENT_PASSWORD_INCORRECT: 'Your current password is not correct.',

    AUTHENTICATION_REQUIRED: 'Your session has expired. Please sign in again.',
    ACCESS_DENIED: 'You do not have permission to do that.',

    VALIDATION_FAILED: 'Please check fields and try again.',
    NOT_FOUND: 'We could not find what you were looking for.',

    ACCOUNT_NOT_FOUND: 'Account not found.',
    ACCOUNT_NOT_LOCKED: 'That account is not locked.',
    CREDIT_UNION_ACCESS_DENIED: 'You do not have access to that credit union.',
    CREDIT_UNION_ADMIN_REQUIRED: 'That action requires the administrator role in this credit union.',
    CREDIT_UNION_NOT_REGISTERED: 'That credit union is not in the register.',
    CREDIT_UNION_ACCESS_NOT_FOUND: 'That user has no access to this credit union.',
    SELF_MODIFICATION_REFUSED: 'You cannot change your own credit-union access.',
    PARTICIPATION_SUBMISSION_NOT_PERMITTED: 'Your access in this credit union does not include submitting participations.',

    REPORT_FILE_TYPE_UNSUPPORTED: 'That report is not available in this format. Please try the other one.',
    REPORT_DATA_NOT_FOUND: 'There is no report data for that period.',
    REPORT_ARCHIVE_NOT_FOUND: 'No archive exists for that credit union and year.',
    REPORT_GENERATION_FAILED: 'We could not generate that report. Please try again.',

    NOTIFICATION_IN_PROGRESS: 'A send is already running. Please try again shortly.',
    NOTIFICATION_ALREADY_SENT: "This period's notification has already been sent.",
    NOTIFICATION_RESULT_NOT_RECORDED: 'The notification was sent, but the result was not recorded. Please contact support before resending.',
    NOTIFICATION_COOLDOWN_ACTIVE: 'This announcement is in its cooldown window. Please try again later.',
    REPORTS_NOT_PUBLISHED: 'Nothing has been published for that period yet.',
    NO_ELIGIBLE_RECIPIENTS: 'No eligible recipients were found.',
    EMAIL_GATEWAY_ERROR: 'The email provider refused the send. Please try again.',

    DEFAULT_SIGNER_PROTECTED: 'The default signer cannot be changed. Make another signer the default first.',

    RATE_LIMITED: 'Too many attempts. Please wait a moment and try again.'
};

export const VIOLATION_MESSAGES: Record<string, string> = {
    'avana.validation.email.address.exists': 'This user already has access to this credit union.'
};
